import {
  fetchPricingEnabled,
  fetchUploadedPricing,
} from '@store/customers/customerDetails/pricingTab';

import { setPricingStore } from './store';

export const getPricingData = async (customerId: number) => {
  const res = await fetchUploadedPricing(customerId);

  if (res && res.isSuccess) {
    setPricingStore('items', res.value.pricingSheetRows);
    setPricingStore('isError', false);
  } else {
    setPricingStore('isError', true);
    setPricingStore('errorMessage', 'Failed to fetch pricing data');
  }
};

export const getPricingEnabled = async (customerId: number) => {
  const res = await fetchPricingEnabled(customerId);
  if (res && res.isSuccess) {
    setPricingStore('isPricingEnabled', res.value);
    setPricingStore('isPricingEnabledError', false);
  } else {
    setPricingStore('isPricingEnabled', false);
    setPricingStore('isPricingEnabledError', true);
  }
};
